import { css } from '@emotion/react';
import React from 'react';
import { UIColorPalette } from './ColorPalette';
import { MEDIA_QUERY_MOBILE } from './mobile_ui/MStyles';

export default function PilesContainerView(props: {
  title: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div css={PileContainerStyles.container} className={props.className}>
      <div css={PileContainerStyles.title}>{props.title}</div>
      {props.children}
    </div>
  );
}

const PileContainerStyles = {
  container: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    padding: 5,
    paddingRight: 10,
    paddingLeft: 10,
    margin: 5,

    [MEDIA_QUERY_MOBILE]: {
      position: 'relative',
      flexDirection: 'row',
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 0,
      paddingBottom: 0,
      margin: 0,

      backgroundColor: UIColorPalette.mPileContainerBG,
      borderRadius: 10,

      boxSizing: 'border-box',
    },
  }),
  title: css({
    textAlign: 'center',
    fontSize: 12,
    padding: 1,
    color: UIColorPalette.gamePileTitleText,

    [MEDIA_QUERY_MOBILE]: {
      position: 'absolute',
      left: 14,

      writingMode: 'vertical-rl',
      transform: 'translatex(-50%) rotate(180deg)',
      transformOrigin: 'center',
    },
  }),
};
